import Keycloak from 'keycloak-js'
import { url } from 'utils'

export const init = async (action, store, driver) => {
  const configKeycloak = await driver.http('APP_CONFIG').get(url.appendVersion('/config/config.json'))
  const keycloak = new Keycloak({
    url: configKeycloak.keycloakUrl,
    realm: configKeycloak.keycloakRealm,
    clientId: configKeycloak.keycloakClientId,
  })
  store.config.keycloakConfig.set(configKeycloak)

  const authenticated = await keycloak.init({ onLoad: 'login-required' })

  if (driver.router.getQueryParam('logout') === 'true') {
    console.log('logout')
    keycloak.logout({ redirectUri: driver.window.document.location.href.replace('logout', 'loggedOut') })
    return
  }

  const userInfo = await keycloak.loadUserInfo()
  driver.http.setAuthorization(`Bearer ${keycloak.token}`)
  store.config.keycloak.set(keycloak)
  store.data.user.set(userInfo)
  store.ui.authorized.set(authenticated)
  console.log('authenticated', authenticated)
  store.dispatch({ type: '@@krml/AUTHENTIFICATION/ENDED', payload: { isAuthorized: authenticated } })
}
